import Vue from "vue";
import webLanguage from "./webLanguage";
import webConfig from "@/config/web.config/index";
async function initLanguage() {
    let currentLanguage = window.sessionStorage.getItem('currentLanguage');
    //  本地开启语言切换--用于测试
    if (currentLanguage && webConfig.NODE_ENV == 'development') {
        webLanguage = currentLanguage;
    }
    let currentLanguageCongig = require(`./${webLanguage}.json`)
    Vue.prototype.$t = currentLanguageCongig
    // 日期选择控件多语言配置
    if (currentLanguageCongig && currentLanguageCongig.calendarLanguage) {
        window.VueCalendarLang = function () {
            return currentLanguageCongig.calendarLanguage
        };
    }
    Vue.prototype.$language = webLanguage
}

initLanguage()
